import React, { useState, useRef, useEffect } from 'react';
import { MdAdd, MdSettings, MdArrowDropDown, MdFilterList, MdLocationOn, MdEdit, MdVisibility, MdBusiness, MdSearch } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import ZoneStatusUpdateModal from './ZoneStatusUpdateModal';
import AddZoneModal from './AddZoneModal';
import ViewDetailsModal from './ViewDetailsModal';
import TableLoadingWrapper from './TableLoadingWrapper';
import SearchableDropdown from './SearchableDropdown';
import '../styles/views.css';

const ZonesView = ({
  pagedFilteredData,
  searchTerm,
  setSearchTerm,
  pageCount,
  handlePageClick,
  isAddModalOpen,
  setIsAddModalOpen,
  setEditZone,
  setIsEditModalOpen,
  currentPage,
  totalRows,
  itemsPerPage,
  statusFilter,
  setStatusFilter,
  mmdaFilter,
  setMmdaFilter,
  mmdas,
  fetchData,
  showPopup,
  onStatusUpdate,
}) => {
  const [openPopupIndex, setOpenPopupIndex] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [selectedZone, setSelectedZone] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewZone, setViewZone] = useState(null);
  const popupRefs = useRef({});
 
   // Close popup if click outside
   useEffect(() => {
     const handleClickOutside = (event) => {
      if (openPopupIndex !== null) {
        const popup = popupRefs.current[openPopupIndex];
        if (popup && !popup.contains(event.target)) {
          setOpenPopupIndex(null);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openPopupIndex]);

  return (
    <>
      {/* Zone Management Header */}
      <div style={{
        marginBottom: 24,
        borderRadius: 12,
        border: '1px solid #f0f0f0'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MdLocationOn size={24} style={{ color: '#1976d2' }} />
            <h3 style={{ margin: 0, color: '#333', fontSize: 18, fontWeight: '600' }}>
              Zone Management
            </h3>
            <span style={{
              padding: '4px 12px',
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600'
            }}>
              {pagedFilteredData?.length || 0} Zones
            </span>
          </div>
        </div>

        {/* Search and Filter Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', flex: '1', minWidth: 300 }}>
            <MdSearch size={20} style={{
              position: 'absolute',
              left: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              color: '#666'
            }} />
            <input
              type="text"
              placeholder="Search zones by name or description..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px 10px 40px',
                borderRadius: 8,
                border: '1px solid #ddd',
                fontSize: 14,
                outline: 'none',
                transition: 'border-color 0.2s ease',
                boxSizing: 'border-box'
              }}
              onFocus={e => e.target.style.borderColor = '#1976d2'}
              onBlur={e => e.target.style.borderColor = '#ddd'}
            />
          </div>

          {/* Status Filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdFilterList size={20} style={{ color: '#666' }} />
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              style={{
                padding: '10px 12px',
                borderRadius: 8,
                border: '1px solid #ddd',
                fontSize: 14,
                outline: 'none',
                backgroundColor: '#fff',
                cursor: 'pointer',
                minWidth: 120
              }}
            >
              <option value="All">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          {/* MMDA Filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <MdBusiness size={20} style={{ color: '#666' }} />
            <SearchableDropdown
              options={[
                { value: "All", label: "All MMDAs" },
                ...(mmdas?.map((mmda) => ({ value: mmda.name, label: mmda.name })) || [])
              ]}
              value={mmdaFilter}
              onChange={setMmdaFilter}
              placeholder="All MMDAs"
            />
          </div>
        </div>
      </div>

      {/* Zones Table - MMDA Style */}
      <TableLoadingWrapper loading={false}>
        <div style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                <th>Zone Name</th>
                <th>MMDA Name</th>
                <th>Description</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pagedFilteredData.map((row, i) => (
                <tr key={i} style={{ cursor: 'default' }}>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

                      <strong>{row.zone_name}</strong>
                    </div>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#e3f2fd',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      color: '#1976d2'
                    }}>
                      {row.mmda_name}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: 4,
                      fontSize: 12,
                      color: '#666'
                    }}>
                      {row.description || 'No description'}
                    </span>
                  </td>
                  <td>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: 4,
                      fontSize: 12,
                      fontWeight: 'bold',
                      backgroundColor: row.status === 'active' ? '#e8f5e8' : '#ffebee',
                      color: row.status === 'active' ? '#2e7d32' : '#c62828'
                    }}>
                      {(row.status || 'active').charAt(0).toUpperCase() + (row.status || 'active').slice(1)}
                    </span>
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button
                        onClick={() => {
                          // For zones, we can use the current row data as it already has all the info
                          setViewZone(row);
                          setIsViewModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#4caf50',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdVisibility size={14} />
                        View
                      </button>

                      <button
                        onClick={() => {
                          setEditZone(row);
                          setIsEditModalOpen(true);
                        }}
                        style={{
                          padding: '6px 12px',
                          backgroundColor: '#ff9800',
                          color: 'white',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          fontSize: 12,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 4
                        }}
                      >
                        <MdEdit size={14} />
                        Edit
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </TableLoadingWrapper>

      {/* Enhanced Pagination */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 24,
        padding: '16px 20px',
        backgroundColor: '#f8f9fa',
        borderRadius: 12,
        border: '1px solid #e9ecef'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{
            color: '#495057',
            fontSize: 14,
            fontWeight: '500'
          }}>
            Showing {currentPage * itemsPerPage + 1} to {Math.min((currentPage + 1) * itemsPerPage, totalRows)} of {totalRows} zones
          </span>
          {totalRows > 0 && (
            <span style={{
              padding: '4px 8px',
              backgroundColor: '#e3f2fd',
              color: '#1976d2',
              borderRadius: 6,
              fontSize: 12,
              fontWeight: '600'
            }}>
              Page {currentPage + 1} of {pageCount}
            </span>
          )}
        </div>

        {pageCount > 1 && (
          <ReactPaginate
            previousLabel={'← Previous'}
            nextLabel={'Next →'}
            breakLabel={'...'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            forcePage={currentPage}
          />
        )}
      </div>

      {/* Zone Management Info */}


      <ZoneStatusUpdateModal
        isOpen={isStatusModalOpen}
        onClose={() => setIsStatusModalOpen(false)}
        zone={selectedZone}
        onStatusUpdate={onStatusUpdate}
      />

      {/* Add Zone Modal */}
      <AddZoneModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        showPopup={showPopup}
        fetchData={fetchData}
        mmdas={[]}
      />

      {/* View Details Modal */}
      <ViewDetailsModal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        data={viewZone}
        type="zone"
        title="Zone Details"
      />
    </>
  );
};

export default ZonesView;